var React = require('react');

function IconUsCheck (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-us-check"),React.createElement("g",{"id":"L","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"L-1366-PDP-EFK---Us-vs-Them","transform":"translate(-926.000000, -2181.000000)","stroke":"#142B6F","strokeWidth":"3"},React.createElement("g",{"id":"US-V-THEM","transform":"translate(298.000000, 1898.000000)"},React.createElement("g",{"id":"Table","transform":"translate(0.000000, 254.000000)"},React.createElement("g",{"id":"icon-us","transform":"translate(628.000000, 29.000000)"},React.createElement("polyline",{"id":"Path","points":"2 12.1697116 9.2632012 19.5 24 4.5"}))))))]);
}

IconUsCheck.defaultProps = {"width":"26px","height":"24px","viewBox":"0 0 26 24","version":"1.1"};

module.exports = IconUsCheck;

IconUsCheck.default = IconUsCheck;
